import React from 'react';
import { Modal, Table, Form, Empty, Input, Button, Select, Icon, DatePicker, } from 'antd';
import global from '../../../common/utility/global';
import moment from "moment";
import { FACTURA } from '../../../common/types/tipoComprobanteType';

const { Search } = Input;
const { Option } = Select;

class DetalleModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                const data = {
                    identifier: global.fetchUniqueCode(),
                    id: values.id == undefined ? 0 : values.id,
                    tipoComprobante: values.tipoComprobante,
                    serie: values.serie.toUpperCase(),
                    documentoSerie: values.serie.toUpperCase() + "-" + values.numero,
                    documento: values.numero,
                    fechaEmision: values.fechaEmision.format("DD/MM/YYYY"),
                    idMoneda: values.moneda.key,
                    tipoCambio: 0,
                    cuota: parseInt(values.cuota),
                    total: parseFloat(values.total),
                    fechaRetencion: values.fechaRetencion.format("DD/MM/YYYY"),
                    totalRetencion: values.moneda.key == 1 ? parseFloat(values.totalRetencion) : parseFloat(values.totalRetencion) * parseFloat(this.props.tipoCambio),
                    totalPagar: parseFloat(values.totalPagar),
                    totalPagado: values.moneda.key == 1 ? parseFloat(values.totalPagado) : parseFloat(values.totalPagado) * parseFloat(this.props.tipoCambio),
                    idTipoComprobante: FACTURA.ID,
                }

                this.props.handleDetalleOk(data, this.props.form);
            }
        });
    };


    handleCompleteDecimals = (property, value) => {
        if (value === "" || isNaN(parseFloat(value).toFixed(3)))
            this.props.form.setFieldsValue({ [property]: "0.000" });
        else
            this.props.form.setFieldsValue({
                [property]: parseFloat(value).toFixed(3),
            });
    };


    handleCalculate = (property, value) => {
        if (value === "" || isNaN(parseFloat(value).toFixed(2)))
            this.props.form.setFieldsValue({ [property]: "0.00" });
        else
            var retencion = parseFloat(value).toFixed(2) * 0.03;

        this.props.form.setFieldsValue({
            [property]: parseFloat(value).toFixed(2),
            totalRetencion: parseFloat(retencion).toFixed(2),
            totalPagado: (parseFloat(value) - parseFloat(retencion)).toFixed(2),
        });
    };


    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;

        return (
            <Modal
                title={this.props.formValues.id === 0 ? "Registrar Retención" : "Modificar Retención"}
                visible={this.props.visible}
                style={{ top: 30 }}
                width="800px"
                cancelText={"Cancelar"}
                okText={"Agregar"}

                onCancel={() => {
                    this.props.form.resetFields();
                    this.props.onClose()
                }}
                onOk={this.handleOk}
            >
                <Form>
                    <div className="row">

                        <div className="col-md-6 form-group">
                            <Form.Item label="Tipo de comprobante">
                                {getFieldDecorator("tipoComprobante", {
                                    initialValue: this.props.formValues.tipoComprobante,
                                })(
                                    <Input
                                        readOnly
                                        placeholder="Ingresar Tipo de comprobante"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-3 form-group">
                            <Form.Item label="Serie">
                                {getFieldDecorator("serie", {
                                    initialValue: this.props.formValues.serie,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Requerido",
                                        },
                                    ],
                                })(
                                    <Input
                                        placeholder="Ingresar Serie"
                                        autoComplete="off"
                                        maxLength="4"
                                    />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-3 form-group">
                            <Form.Item label="Número">
                                {getFieldDecorator("numero", {
                                    initialValue: this.props.formValues.numero,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Requerido",
                                        },
                                    ],
                                })(
                                    <Input
                                        placeholder="Ingresar Número"
                                        autoComplete="off"
                                        maxLength="8"
                                    />
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-3 form-group">
                            <Form.Item label="Fecha de emisión">
                                {getFieldDecorator("fechaEmision", {
                                    initialValue: moment(
                                        this.props.formValues.fechaEmision,
                                        "DD/MM/YYYY"
                                    ),
                                    rules: [
                                        {
                                            type: "object",
                                            required: true,
                                            message: "Requerido",
                                        },
                                    ],
                                })(
                                    <DatePicker
                                        className="first-input"
                                        placeholder="Seleccione fecha"
                                        prefix={
                                            <Icon
                                                type="filter"
                                                style={{ color: "rgba(0,0,0,.25)" }}
                                            />
                                        }
                                        format="DD/MM/YYYY"
                                        onChange={(moment, value) => this.props.onChange("fechaEmision", value, this.props.form)
                                        }
                                    />
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-3 form-group">
                            <Form.Item label="Moneda">
                                {getFieldDecorator("moneda", {
                                    initialValue: this.props.formValues.moneda
                                        ? { key: this.props.formValues.moneda }
                                        : undefined,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obligatorio.",
                                        },
                                    ],
                                })(
                                    <Select
                                        showSearch
                                        labelInValue
                                        placeholder={"Seleccione Moneda"}
                                        optionFilterProp="children"
                                        onChange={(option) => {
                                            this.props.form.setFieldsValue(
                                                {
                                                    idListaPrecio: undefined,
                                                },
                                                () => {
                                                    this.props.onChange("idMoneda", option.key);
                                                }
                                            );
                                        }}
                                    >
                                        {this.props.listaMoneda.map((item) => (
                                            <Option key={item.id} value={item.id}>
                                                {item.nombre}
                                            </Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>


                        <div className="col-md-3 form-group">
                            <Form.Item label="Numero Cuota">
                                {getFieldDecorator("cuota", {
                                    initialValue: this.props.formValues.cuota,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Requerido",
                                        },
                                    ],
                                })(
                                    <Input
                                        placeholder="Numero Cuota"
                                        autoComplete="off"
                                        maxLength="2"

                                    />
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-3 form-group">
                            <Form.Item label="Total comprobante">
                                {getFieldDecorator("total", {
                                    initialValue: this.props.formValues.total,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Requerido",
                                        },
                                    ],
                                })(
                                    <Input
                                        placeholder="Total comprobante"
                                        autoComplete="off"
                                        onBlur={(e) =>
                                            this.handleCalculate("total", e.target.value)
                                        }
                                    />
                                )}
                            </Form.Item>
                        </div>
                        <div hidden={true}>

                            <div className="col-md-3 form-group">
                                <Form.Item label="Fecha de retención">
                                    {getFieldDecorator("fechaRetencion", {
                                        initialValue: moment(
                                            this.props.formValues.fechaRetencion,
                                            "DD/MM/YYYY"
                                        ),
                                        rules: [
                                            {
                                                type: "object",
                                                required: true,
                                                message: "Requerido",
                                            },
                                        ],
                                    })(
                                        <DatePicker
                                            className="first-input"
                                            placeholder="Seleccione fecha"
                                            prefix={
                                                <Icon
                                                    type="filter"
                                                    style={{ color: "rgba(0,0,0,.25)" }}
                                                />
                                            }
                                            format="DD/MM/YYYY"
                                        />
                                    )}
                                </Form.Item>
                            </div>

                            <div className="col-md-3 form-group">
                                <Form.Item label="Total retención ">
                                    {getFieldDecorator("totalRetencion", {
                                        initialValue: this.props.formValues.totalRetencion,
                                        rules: [
                                            {
                                                required: true,
                                                message: "Requerido",
                                            },
                                        ],
                                    })(
                                        <Input
                                            placeholder="Ingresar Observación"
                                            autoComplete="off"
                                            readOnly
                                        />
                                    )}
                                </Form.Item>
                            </div>

                            <div className="col-md-3 form-group">
                                <Form.Item label="Total a pagar">
                                    {getFieldDecorator("totalPagar", {
                                        initialValue: this.props.formValues.totalPagar,
                                        rules: [
                                            {
                                                required: true,
                                                message: "Requerido",
                                            },
                                        ],
                                    })(
                                        <Input
                                            placeholder="Ingresar Total a pagar"
                                            autoComplete="off"
                                        />
                                    )}
                                </Form.Item>
                            </div>

                            <div className="col-md-3 form-group">
                                <Form.Item label="Total pagado">
                                    {getFieldDecorator("totalPagado", {
                                        initialValue: this.props.formValues.totalPagado,
                                        rules: [
                                            {
                                                required: true,
                                                message: "Requerido",
                                            },
                                        ],
                                    })(
                                        <Input
                                            placeholder="Ingresar Total pagado"
                                            autoComplete="off"
                                        />
                                    )}
                                </Form.Item>
                            </div>
                        </div>

                    </div>

                </Form>
            </Modal>
        );
    }
}
export default Form.create()(DetalleModal)